import {Component, Input, Output, EventEmitter} from '@angular/core';
import { Mag2ApiClient } from "src/lib/api-client/mag2-api-client";
import { environment } from "src/env/environment";
import { Mag2LocalStorage } from "src/lib/mag2-local-storage";

@Component({
  selector: 'admin-sidebar',
  templateUrl: './admin-sidebar.component.html',
  styleUrls: ['../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss', './admin-sidebar.component.scss']
})

export class AdminSidebarComponent {

  isToggled: boolean = false;
  userExpanded = false;
  creatorExpanded = false;
  liveExpanded = false;
  otherSettingExpanded = false;
  pointExpanded = false;
  giftExpanded = false;
  transferExpanded = false;
  historyStatExpanded = false;

  @Input() authority: any;
  @Output() menuEvent = new EventEmitter<string>();

  selectMenu(menuItem: string): void {
    this.menuEvent.emit(menuItem);
  }

  toggleSidebar(): void {
    this.isToggled = !this.isToggled;
  }

  /**
   * ステージ・ローカル環境でCookie に入っている __USER_ID を認証代わりに利用する場合、実際には API を呼び出さず、Cookie の __USER_ID を削除する。
   * この Cookie の __USER_ID は /debug ページで削除可能。
   */
  onLogout(): void {
    if( window.confirm("ログアウトしますか？") ) {
      if (environment.name !== 'production') {
        const userId = Mag2LocalStorage.getUserId();
        if (userId !== null) {
          Mag2LocalStorage.removeUserId();
          window.location.href = environment.baseURL.mag2mypage + "Logout.do";
          return 
        }
      }
  
      Mag2ApiClient.logout().subscribe( x => {
        if( x === "NOT_AUTHORIZED" || x?.error != null) {
          alert("ログアウトに失敗しました")
          return 
        }
        window.location.href = environment.baseURL.mag2mypage + "Logout.do";
      });
    }
    
  }
}
